import { Observable, Subscriber, Subject } from 'rxjs';

const subjects = {
  menuSearch: new Subject(),
  closeModal: new Subject(),
  drawer: new Subject(),
  nowPlaying: new Subject(),
  stopZD: new Subject(),
  stopFM: new Subject(),
  currentComponent: new Subject(),
  showMenu: new Subject(),
  episode: new Subject()
}


export default subjects
